// import itemI18 from "@/components/item/item-i18";
import supplierI18 from "@/components/supplier/supplier-i18";
import categoryI18 from "@/components/category/category-i18";
import customerI18 from "@/components/customer/customer-i18";
import employeeI18 from "@/components/employee/employee-i18";
import expenseCategoryI18 from "@/components/expense-category/expense-category-i18";
import financeAccountI18 from "@/components/finance-account/finance-account-i18";
import financeCategoryI18 from "@/components/finance-category/finance-category-i18";
import financeDebtI18 from "@/components/finance-debt/finance-debt-i18";
import financeTransferI18 from "@/components/finance-transfer/finance-transfer-i18";
import incomeCategoryI18 from "@/components/income-category/income-category-i18";
import orderI18 from "@/components/order/order-i18";
import saleReturnI18 from "@/components/sale-return/sale-return-i18";
import stockBatchI18 from "@/components/stock-batch/stock-batch-i18";
import stockQuantityI18 from "@/components/stock-batch/stock-quantity-i18";
import stockTransferI18 from "@/components/stock-transfer/stock-transfer-i18";
import supplyReturnI18 from "@/components/supply-return/supply-return-i18";
import warehouseI18 from "@/components/warehouse/warehouse-i18";
import productI18 from "@/components/product/product-i18";
import incomeI18 from "@/components/income/income-i18";
import expenseI18 from "@/components/expense/expense-i18";
import financeTransactionI18 from "@/components/finance-transaction/finance-transaction-i18";
import userI18 from "@/components/user/user-i18";
import auditLogI18 from "@/components/audit-log/audit-log-i18";

export default {
  ...userI18,
  ...supplierI18,
  ...categoryI18,
  ...customerI18,
  ...employeeI18,
  ...expenseCategoryI18,
  ...financeAccountI18,
  ...financeCategoryI18,
  ...financeDebtI18,
  ...financeTransferI18,
  ...financeTransferI18,
  ...financeTransactionI18,
  ...incomeCategoryI18,
  ...orderI18,
  ...saleReturnI18,
  ...stockBatchI18,
  ...stockQuantityI18,
  ...stockTransferI18,
  ...supplierI18,
  ...supplyReturnI18,
  ...warehouseI18,
  ...productI18,
  ...incomeI18,
  ...expenseI18,
  ...employeeI18,
  ...auditLogI18,
  "All time": "Tout les temps",
  Apply: "Appliquer",
  Refresh: "Rafraîchir",
  Language: "Langue",
  "Order lists": "Liste des commandes",
  "Created by": "Créé par",
  "Updated by": "Modifié par",
  en: "fr",
  "Password changed with success": "Mot de passe modifié avec succès",
  Back: "Retour",
  back: "retour",
  "Profile information": "Informations du profil",
  "Profile Picture": "Photo de profil",
  Firstname: "Prénom",
  firstname: "prénom",
  Lastname: "Nom",
  lastname: "nom",
  Country: "Pays",
  country: "pays",
  "State/Region": "État/Région",
  City: "Ville",
  city: "ville",
  "Street address": "Adresse",
  "Update profile informations": "Mettre à jour les informations du profil",
  "Old password": "Ancien mot de passe",
  "New password": "Nouveau mot de passe",
  "Change password": "Changer le mot de passe",
  English: "Anglais",
  French: "Français",
  Search: "Search",
  Profile: "Profil",
  Cost: "Coût",
  "Stock Transfers": "Transferts de stock",
  "stock transfers": "transferts de stock",
  "Transfer Stock": "Transférer du stock",
  "transfer stock": "transférer du stock",
  Remove: "Supprimer",
  "Unit type": "Unité de mesure",
  "Add unit type": "Ajouter une type d'unité",
  "Product types": "Types de produit",
  "Add product type": "Ajouter un type de produit",
  "All statuses": "Tous les status",
  "All categories": "Toutes les catégories",
  "No data available": "Aucune donnée disponible",
  "Enter a keyword to make a research":
    "Entrer un mot clé pour effectuer la recherche",
  Settings: "Paramètres",
  Dashboard: "Tableau de bord",
  Orders: "Commandes",
  Returns: "Retours",
  Products: "Produits",
  "Product list": "Liste des produits",
  Categories: "Catégories",
  Suppliers: "Fournisseurs",
  Types: "Types",
  POS: "Point de vente",
  Customers: "Clients",
  "Select-Shop": "Sélectionner une boutique",
  Inventory: "Inventaire",
  Warehouses: "Entrepôts",
  "Inventory Items": "Articles en stock",
  "Stock transfers": "Transferts de stock",
  "Supply returns": "Retours fournisseurs",
  Employees: "Employés",
  Finance: "Finance",
  "Treasury account": "Compte de trésorerie",
  Transfers: "Transferts",
  "Income categories": "Catégories de revenus",
  Income: "Revenus",
  "Expense categories": "Catégories de dépenses",
  Expenses: "Dépenses",
  Debts: "Dettes",
  "Customer debts": "Dettes clients",
  "Supplier credits": "Crédits fournisseurs",
  "Global Settings": "Paramètres globaux",
  "Help/Support": "Aide/Support",
  "Sales trendes": "Tendances des ventes",
  Sales: "Ventes",
  "Top products": "Top produits",
  "Incomes and expenses overtime": "Revenus et dépenses au fil du temps",
  Incomes: "Revenus",
  "Total Balance": "Solde Total",
  "Last 7 days sales": "Ventes des 7 derniers jours",
  "Top categories": "Top catégories",
  "Drop or click select to an image":
    "Glissez-déposez ou cliquez pour sélectionner une image",
  "Go back": "Retour",
  "Total Revenue": "Revenu Total",
  "New Customers": "Nouveaux Clients",
  "First name": "Prenom",
  "Last name": "Nom de famille",
  Sessions: "Sessions",
  "Welcome to SaleBox! 👋": "Bienvenue sur SaleBox ! 👋",
  "Please sign-in to your account and start the adventure":
    "Veuillez vous connecter à votre compte pour commencer l'aventure",
  Login: "Connexion",
  "New on our platform?": "Nouveau sur notre plateforme ?",
  "Create an account": "Créer un compte",
  "Total Growth": "Croissance Totale",
  "Adventure starts here": "L'aventure commence ici",
  "Make your app management easy and fun!":
    "Rendez la gestion de votre application facile et amusante !",
  Password: "Mot de passe",
  "Already have an account?": "Vous avez déjà un compte ?",
  "Sign in instead": "Se connecter à la place",
  "Setup your business": "Configurez votre entreprise",
  "Provide the essential information about your business so we can helpyou manage it efficiently.":
    "Fournissez les informations essentielles sur votre entreprise afin que nous puissions vous aider à la gérer efficacement.",
  "Your business informations": "Vos informations d'entreprise",
  "Full Business Name": "Nom complet de l'entreprise",
  "Business Type": "Type d'entreprise",
  "Number of Employees": "Nombre d'employés",
  "Tax ID Number (Optional)": "Numéro d'identification fiscale (Optionnel)",
  "Your business address": "Votre adresse d'entreprise",
  "State/Region/Province": "État/Région/Province",
  "Street Address": "Adresse",
  "Your business official documents": "Vos documents officiels d'entreprise",
  "National ID Card (Front)": "Carte d'identité nationale (Recto)",
  "National ID Card (Back)": "Carte d'identité nationale (Verso)",
  "Taxation Documents": "Documents fiscaux",
  Continue: "Continuer",
  "Add a shop": "Ajouter une boutique",
  "Add a new shop to your business. Fill in the details step-by-step.":
    "Ajoutez une nouvelle boutique à votre entreprise. Remplissez les détails étape par étape.",
  "Shop information": "Informations sur la boutique",
  "Shop Name": "Nom de la boutique",
  "Phone number": "Numéro de téléphone",
  "Email address": "Adresse email",
  "Shop address": "Adresse de la boutique",
  "Use business address for shop location":
    "Utiliser l'adresse de l'entreprise pour l'emplacement de la boutique",
  "Shop logo (optional)": "Logo de la boutique (optionnel)",
  "Submit the shop": "Enregistrer la boutique",
  "Select a Shop": "Sélectionner une boutique",
  "Choose which shop you want to manage":
    "Choisissez la boutique que vous souhaitez gérer",
  "No shop selected": "Aucune boutique sélectionnée",
  "Add New Shop": "Ajouter une nouvelle boutique",
  "Add a business": "Ajouter une entreprise",
  Logout: "Déconnexion",
  "Create your account": "Créer votre compte",
  "Settings updated successfully": "Paramètres mis à jour avec succès",
  settings: "paramètres",
  "Shop Logo": "Logo de la boutique",
  language: "langue",
  english: "anglais",
  french: "français",
  Currency: "Devise",
  currency: "devise",
  "Receipt bottom message": "Message en bas de ticket",
  "Update Settings": "Mettre à jour les paramètres",
} as any;
